import React from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';

interface Props {
    children: React.ReactNode;
}

export const IdentificationOnboardingFormFooter = ({ children }: Props) => (
    <Container marginTop="auto" paddingTop={{ default: '16', lg: '0' }}>
        <Stack
            position={{ default: 'fixed', lg: 'static' }}
            wrap="wrap"
            backgroundColor="white"
            gap="8"
            bottom={0}
            left={0}
            borderColor="grey_500"
            justifyContent="spaceBetween"
            borderStyle="solid"
            borderTopWidth={{ default: 'sm', lg: 0 }}
            paddingTop={{ default: '6', sm: '8' }}
            paddingBottom={{ default: '6', sm: '8', lg: '0' }}
            paddingX={{ default: '6', sm: '8', md: '10', lg: '0' }}
            width="100%"
        >
            {children}
        </Stack>
    </Container>
);
